import RadioOption from './RadioOption';

interface Props {
  name: string;
  required: boolean;
}

const BooleanInputs = ({ name, required }: Props) => {
  return (
    <div>
      <fieldset>
        <div>
          <RadioOption name={name} value="true" label="True" required={required} />
          <RadioOption name={name} value="false" label="False" required={required} />
        </div>
      </fieldset>
    </div>
  );
};

export default BooleanInputs;
